import React from "react";
import { Link } from "react-router-dom";
import { club } from "../mock/mock";

function Legal({ title, subtitle, children }) {
  return (
    <div>
      {/* Schlichter Kopfbereich */}
      <section className="bg-primary text-primary-foreground pt-32 pb-14">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <span className="inline-block text-accent text-sm font-600 uppercase tracking-[0.25em] mb-3">
            Rechtliches
          </span>
          <h1 className="font-serif text-4xl md:text-5xl font-600">{title}</h1>
          {subtitle && (
            <p className="mt-3 text-primary-foreground/80 text-lg font-300">{subtitle}</p>
          )}
        </div>
      </section>
      <section className="py-16 bg-background">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 legal-body">{children}</div>
      </section>
    </div>
  );
}

function H2({ children }) {
  return (
    <h2 className="font-serif text-2xl font-600 text-foreground mt-10 mb-3 first:mt-0">
      {children}
    </h2>
  );
}

function P({ children }) {
  return <p className="text-muted-foreground leading-relaxed mb-3">{children}</p>;
}

export default function Impressum() {
  return (
    <Legal title="Impressum" subtitle="Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz).">
      <H2>Diensteanbieter</H2>
      <P>
        {club.name}
        <br />
        {club.address.heim}
        <br />
        {club.address.city}
      </P>

      <H2>Vereinsregister</H2>
      <P>
        Eingetragen im Vereinsregister des Amtsgerichts Fürth.
        <br />
        Registernummer: <strong className="text-foreground">VR 491</strong>
      </P>

      <H2>Vertreten durch den Vorstand</H2>
      <P>
        1. Vorsitzender: Martin Stade
        <br />
        2. Vorsitzender: Dominik Vogel
      </P>

      <H2>Kontakt</H2>
      <P>
        E-Mail:{" "}
        <a
          href={`mailto:${club.emails.vorstand}`}
          className="text-primary font-500 underline underline-offset-2 break-all"
        >
          {club.emails.vorstand}
        </a>
        <br />
        Ein telefonischer Kontakt besteht für den Verein nicht; wir sind per
        E-Mail erreichbar.
      </P>

      <H2>Redaktionell verantwortlich (§ 18 Abs. 2 MStV)</H2>
      <P>
        Verantwortlich für die Inhalte dieser Website ist der Vorstand des
        {" "}{club.name}, Anschrift wie oben.
      </P>

      <H2>EU-Streitschlichtung</H2>
      <P>
        Die Europäische Kommission hatte eine Plattform zur
        Online-Streitbeilegung (OS) bereitgestellt. Diese Plattform wurde von
        der EU-Kommission zum 20. Juli 2025 endgültig eingestellt und steht
        daher nicht mehr zur Verfügung.
      </P>

      <H2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</H2>
      <P>
        Wir sind nicht bereit und nicht verpflichtet, an
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
      </P>

      <H2>Haftung für Inhalte</H2>
      <P>
        Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach
        den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht
        verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
        überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
        Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
        Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon
        unberührt.
      </P>

      <H2>Haftung für Links</H2>
      <P>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Bei Bekanntwerden von Rechtsverletzungen werden wir
        derartige Links umgehend entfernen.
      </P>

      <H2>Urheberrecht</H2>
      <P>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
      </P>

      <div className="mt-8">
        <Link to="/datenschutz" className="text-primary font-500 underline underline-offset-2">
          Zur Datenschutzerklärung
        </Link>
      </div>
    </Legal>
  );
}
